import { Center, Loader } from '@mantine/core';

export const PageLoader = () => {
  return (
    <Center style={{ width: '100%', height: '90vh' }}>
      <Loader size="xl" variant="bars" color="blue" />
    </Center>
  );
};
